import { jsx as _jsx } from "react/jsx-runtime";
import { TextareaAutosize } from '@mui/material';
import { theme } from '../themes';
export const TextareaStyled = (props) => {
    const { width, ...rest } = props;
    return (_jsx(TextareaAutosize, { ...rest, style: {
            width: width,
            fontFamily: theme.typography.fontFamily,
            padding: '1rem',
            fontSize: theme.typography.fontSize,
        } }));
};
